module.exports = __webpack_public_path__ + "static/media/founder.13215362.jpg";